import { anim, prog, stagger } from '../../../motion'
import { Phone, Shape } from '../../../primitives'
import { Fit, Line, Words } from '../../../v2/kit'
import { useCopy } from '../../i18n'
import { toTop } from '../../kit'
import { LINKS } from '../copy'

const STRENGTH_SHAPES = [
  ['dot', 'pink'],
  ['tri', 'yellow'],
  ['sq', 'green']
]

// Bewertungen ziehen in verschiedenen Tempi am Smartphone vorbei (Parallaxe)
const REVIEWS = [
  { at: [0.08, 0.6], x: -29, y: 14, travel: 50 },
  { at: [0.14, 0.68], x: 2, y: 40, travel: 70 },
  { at: [0.2, 0.76], x: -27, y: 66, travel: 90 }
]

const NARROW = { maxW: 0.6, maxH: 0.86 }

export default function CandApp() {
  const c = useCopy('app')
  const strengths = useCopy('ablauf').strengths

  return (
    <div className='cin-full ch-app'>
      <div className='ch-app__text'>
        <Line at={[0, 0.06]} className='cin-eyebrow cin-eyebrow--light'>
          {c.eyebrow}
        </Line>
        <h2 className='cin-title'>
          <Words text={c.title} at={[0.02, 0.16]} dim={0.22} />
        </h2>
        <Line at={[0.14, 0.2]} y={20} className='ch-app__copy'>
          {c.text}
        </Line>
        <div className='ch-stores' style={anim({ at: [0.2, 0.26], y: 30 })}>
          <a
            className='ch-store'
            href={LINKS.appStore}
            target='_blank'
            rel='noreferrer'
          >
            <small>{c.appStore[0]}</small>
            {c.appStore[1]}
          </a>
          <a
            className='ch-store'
            href={LINKS.googlePlay}
            target='_blank'
            rel='noreferrer'
          >
            <small>{c.googlePlay[0]}</small>
            {c.googlePlay[1]}
          </a>
        </div>
      </div>

      <div className='ch-app__stage'>
        <Fit
          w={260}
          h={540}
          maxW={0.6}
          maxH={0.74}
          narrow={NARROW}
          className='ch-app__phone'
        >
          <div style={anim({ at: [0.02, 0.14], y: 160, s: 0.9 })}>
            <Phone x={0} y={0}>
              <div className='sty-abs sty-screen'>
                <div className='sty-h4'>{c.phoneTitle}</div>
                <div className='sty-muted sty-small'>{c.sample}</div>
                <div className='ch-jobs'>
                  {c.jobs.map(([job, fit], i) => (
                    <div
                      key={job}
                      className='ch-job'
                      style={anim({
                        at: stagger(0.16, 0.03, 0.08, i),
                        x: 30,
                        y: 0
                      })}
                    >
                      <div className='ch-job__row'>
                        <span>{job}</span>
                        <b>{fit}&nbsp;%</b>
                      </div>
                      <div className='ch-job__track'>
                        <i
                          style={{
                            ...prog(stagger(0.2, 0.03, 0.14, i)),
                            transform: `scaleX(calc(var(--p) * ${fit / 100}))`
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div className='ch-app__strengths'>
                  {strengths.map((s, i) => (
                    <div
                      key={s.title}
                      className='ch-app__strength'
                      style={anim({ at: stagger(0.34, 0.03, 0.06, i), y: 20 })}
                    >
                      <Shape
                        kind={STRENGTH_SHAPES[i][0]}
                        color={STRENGTH_SHAPES[i][1]}
                        size={18}
                      />
                      {s.title}
                    </div>
                  ))}
                </div>
              </div>
            </Phone>
          </div>
        </Fit>

        {c.reviews.map((r, i) => (
          <figure
            key={r.who}
            className='ch-review'
            style={{
              ...prog(REVIEWS[i].at),
              '--rx': `${REVIEWS[i].x}cqw`,
              '--ry': `${REVIEWS[i].y}cqh`,
              transform: `translateY(calc((1 - var(--p)) * ${REVIEWS[i].travel}cqh * var(--motion)))`,
              opacity: 'clamp(0, var(--p) * 4, 1)'
            }}
          >
            <div className='ch-review__stars' aria-hidden='true'>
              ★★★★★
            </div>
            <blockquote>{r.quote}</blockquote>
            <figcaption>{r.who}</figcaption>
          </figure>
        ))}
      </div>

      <footer className='ch-footer' style={anim({ at: [0.84, 0.92], y: 30 })}>
        <a href={LINKS.privacy} target='_blank' rel='noreferrer'>
          {c.privacy}
        </a>
        <a href={LINKS.imprint} target='_blank' rel='noreferrer'>
          {c.imprint}
        </a>
        <button type='button' onClick={toTop}>
          {c.top}
        </button>
      </footer>
    </div>
  )
}
